
















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({})
export default class SlideshowItem extends Vue {
    @Prop(String)
    private backgroundImageUrl!: string;
    @Prop(String)
    private title!: string;
    @Prop(String)
    private subTitle!: string;
    @Prop(String)
    private buttonText!: string;
    @Prop(String)
    private buttonLinkUrl!: string;
    @Prop(Number)
    private itemIndex!: number;
    @Prop(Number)
    private totalNumberOfItems!: number;
}
